@if (canCompare()) {
  <app-button
    icon="pi pi-clone"
    label="Comparar com o cliente"
    [outlined]="true"
    size="small"
    title="Ver lado a lado a visão Legatus e a Visão Cliente do mesmo documento"
    data-testid="statement-comparison-open"
    (sendClick)="open()" />
}

<app-dialog
  #dialog
  [key]="'statement-comparison'"
  [action]="'statement-comparison'"
  [headerTheme]="'simple'"
  [title]="'Comparar: visão Legatus × Visão Cliente'"
  [width]="'96vw'"
  [maxWidth]="'1400px'"
  [maxHeight]="'92vh'"
  [hideDefaultFooter]="true">
  @if (opened()) {
    <div class="statement-comparison" data-testid="statement-comparison">
      <div class="statement-comparison__bar">
        <div class="statement-comparison__document">
          <span class="statement-comparison__label">Documento:</span>
          <app-select
            class="statement-comparison__select"
            data-testid="statement-comparison-document"
            [options]="documentOptions()"
            [hasFilter]="documentOptions().length > 6"
            [ngModel]="selectedId()"
            (ngModelChange)="selectDocument($event)" />
        </div>
        <div class="statement-comparison__switch" role="group" aria-label="Demonstrativo comparado">
          <button
            type="button"
            class="statement-comparison__option"
            [class.is-active]="statement() === 'income'"
            [disabled]="!canCompareIncome()"
            data-testid="statement-comparison-income"
            (click)="show('income')">
            DRE
          </button>
          <button
            type="button"
            class="statement-comparison__option"
            [class.is-active]="statement() === 'balance'"
            [disabled]="!canCompareBalance()"
            data-testid="statement-comparison-balance"
            (click)="show('balance')">
            Balanço
          </button>
        </div>
      </div>
      <p class="statement-comparison__hint">
        O mesmo documento nas duas visões: à esquerda o padronizado dele (De/Para), à direita como
        está no documento do cliente. As duas colunas rolam juntas.
      </p>

      <div class="statement-comparison__columns">
        <div class="statement-comparison__column">
          @switch (standardizedState()) {
            @case ('loading') {
              <div class="statement-comparison__loading" aria-label="Carregando o padronizado">
                @for (row of [1, 2, 3, 4, 5, 6]; track row) {
                  <div class="statement-comparison__loading-row"></div>
                }
              </div>
            }
            @case ('error') {
              <p class="statement-comparison__empty" role="alert">
                Não deu para abrir o padronizado deste documento. Ele pode ter voltado para
                validação na Padronização; feche a janela e atualize a página.
              </p>
            }
            @case ('ready') {
              @if (standardized(); as preview) {
                @if (statement() === 'income') {
                  <app-table-incomed-statement
                    [allowExport]="false"
                    [availablePeriods]="null"
                    [showAnalysisColumns]="showAnalysisColumns()"
                    [tableData]="preview.incomeStatementLines ?? []"
                    [subAccountLines]="preview.subAccountLines ?? null"
                    [companyName]="companyName()"
                    [companyId]="companyId()"
                    [valueScale]="valueScale()" />
                } @else {
                  <app-table-balance-sheet
                    [allowExport]="false"
                    [availablePeriods]="null"
                    [showAnalysisColumns]="showAnalysisColumns()"
                    [tableData]="preview.balanceSheetLines ?? []"
                    [subAccountLines]="preview.subAccountLines ?? null"
                    [companyName]="companyName()"
                    [companyId]="companyId()"
                    [valueScale]="valueScale()" />
                }
              }
            }
          }
        </div>

        <div class="statement-comparison__column">
          <app-dfp-panel title="Visão Cliente" [titleNote]="scaleNote()">
            @if (documents().length > 0) {
              <app-original-statement
                [kind]="kind()"
                [companyId]="companyId()"
                [documents]="documents()"
                [selectedId]="selectedId()"
                [showPicker]="false"
                [formatValue]="formatValue" />
            } @else {
              <p class="statement-comparison__empty">
                Nenhum documento lido deste demonstrativo alimenta a tela. Os documentos aparecem
                aqui quando forem validados na Padronização.
              </p>
            }
          </app-dfp-panel>
        </div>
      </div>
    </div>
  }
</app-dialog>
